import paymentsConstants from '../../constants/payments';

export const interpretStripeCardError = (stripeCardError) => {
    const { stripeErrorMessages } = paymentsConstants;

    if (stripeCardError?.decline_code) {
        const declineCodeMessage = stripeErrorMessages[stripeCardError.decline_code];
        if (declineCodeMessage) {
            return declineCodeMessage;
        }
    }

    if (stripeCardError?.code) {
        const codeMessage = stripeErrorMessages[stripeCardError.code];
        if (codeMessage) {
            return codeMessage;
        }
        return stripeCardError?.message;
    }

    return stripeCardError?.message || null;
};
